export default __webpack_public_path__ + "static/media/Notifications_Drawing.bcf7593b.svg";